(function () {
  var AUTOPLAY_FALLBACK = 6000;
  var SWIPE_THRESHOLD = 40;

  function initHeroSlider(root) {
    if (root.heroSliderReady) return;
    root.heroSliderReady = true;

    var track = root.querySelector('[data-hero-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (!track || slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var prevButton = root.querySelector('[data-hero-prev]');
    var nextButton = root.querySelector('[data-hero-next]');
    var status = root.querySelector('[data-hero-status]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-autoplay-interval'), 10) || AUTOPLAY_FALLBACK;
    var current = 0;
    var timer = null;
    var paused = false;
    var touchStartX = null;

    function render() {
      track.style.transform = 'translateX(' + current * -100 + '%)';

      slides.forEach(function (slide, index) {
        var isActive = index === current;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        // Off-screen slides stay rendered, so keep them out of the tab order.
        slide.inert = !isActive;
      });

      dots.forEach(function (dot, index) {
        var isActive = index === current;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        dot.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      if (status) {
        status.textContent = 'Diapositiva ' + (current + 1) + ' de ' + slides.length;
      }
    }

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      render();
    }

    function next() {
      goTo(current + 1);
    }

    function previous() {
      goTo(current - 1);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!autoplayEnabled || paused || reduceMotion.matches || document.hidden) return;
      timer = setInterval(next, interval);
    }

    // Any manual navigation resets the timer so the new slide gets a full turn.
    function navigate(action) {
      action();
      start();
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        navigate(previous);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        navigate(next);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        navigate(function () {
          goTo(index);
        });
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        navigate(previous);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        navigate(next);
      }
    });

    root.addEventListener('mouseenter', function () {
      paused = true;
      stop();
    });

    root.addEventListener('mouseleave', function () {
      paused = false;
      start();
    });

    root.addEventListener('focusin', function () {
      paused = true;
      stop();
    });

    root.addEventListener('focusout', function (event) {
      if (root.contains(event.relatedTarget)) return;
      paused = false;
      start();
    });

    root.addEventListener(
      'touchstart',
      function (event) {
        touchStartX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      function (event) {
        if (touchStartX === null) return;
        var delta = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(delta) < SWIPE_THRESHOLD) return;
        navigate(delta < 0 ? next : previous);
      },
      { passive: true }
    );

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', start);
    }

    // Theme editor: reveal whichever slide the merchant is editing.
    document.addEventListener('shopify:block:select', function (event) {
      if (!root.contains(event.target)) return;
      var index = slides.indexOf(event.target.closest('[data-hero-slide]'));
      if (index === -1) return;
      paused = true;
      stop();
      goTo(index);
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      if (!root.contains(event.target)) return;
      paused = false;
      start();
    });

    render();
    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
